const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m4 19l4-6l4 2l4-5l4 4v5H4m0-7l3-4l4 2l5-6l4 4\"/>"
};
export default data;
